import React from 'react';

const Communications = () => <div><h2>Communications Preferences</h2><p>Feature coming soon.</p></div>;

export default Communications; 